import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center justify-center py-12 px-6 text-center gap-4" };
const _hoisted_2 = ["id", "role"];
const _hoisted_3 = ["id"];
import { computed, useId } from "vue";
import { Button, Tooltip } from "@eudonet/opal";
import ModuleIllustration from "./ModuleIllustration.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModuleState',
    props: {
        type: {},
        title: {},
        description: {},
        ctaLabel: {},
        ctaIcon: {},
        ctaDisabled: { type: Boolean },
        ctaDisabledTooltip: {}
    },
    emits: ["cta"],
    setup(__props) {
        const props = __props;
        // The CTA label is generic on its own ("Reessayer", "Creer") and repeats across modules, so it
        // carries the state's own wording as its description — otherwise control-navigation reaches a
        // button that never says what failed or what is empty.
        const titleId = useId();
        const descriptionId = useId();
        const ctaDescribedBy = computed(() => props.description ? `${titleId} ${descriptionId}` : titleId);
        const illustrationProps = computed(() => props.type === "error"
            ? { iconColor: "#FF993E", glowColor: "var(--colors-warning-100)" }
            : {});
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "illustration", {}, () => [
                    _createVNode(ModuleIllustration, _normalizeProps(_guardReactiveProps(illustrationProps.value)), null, 16 /* FULL_PROPS */)
                ]),
                _createElementVNode("p", {
                    id: _unref(titleId),
                    role: __props.type === 'error' ? 'alert' : undefined,
                    class: "text-xl font-bold text-(--text-text-heading)"
                }, _toDisplayString(__props.title), 9 /* TEXT, PROPS */, _hoisted_2),
                (__props.description)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        id: _unref(descriptionId),
                        class: "text-base font-medium text-(--text-text-body) max-w-sm"
                    }, _toDisplayString(__props.description), 9 /* TEXT, PROPS */, _hoisted_3))
                    : _createCommentVNode("v-if", true),
                (__props.ctaLabel)
                    ? (_openBlock(), _createBlock(_unref(Tooltip), {
                        key: 1,
                        text: __props.ctaDisabledTooltip ?? '',
                        disabled: !__props.ctaDisabled,
                        tabindex: __props.ctaDisabled ? 0 : undefined
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(Button), {
                                variant: "primary",
                                "icon-left": __props.ctaIcon,
                                label: __props.ctaLabel,
                                disabled: __props.ctaDisabled,
                                "aria-describedby": ctaDescribedBy.value,
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cta')))
                            }, null, 8 /* PROPS */, ["icon-left", "label", "disabled", "aria-describedby"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
